import React from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { Grid } from "@mui/material";

const QTPhoneFieldWithLabelSection = ({
  label,
  value,
  onChange,
  disabled,
  editEnabled,
}) => {
  return (
    <Grid container alignItems={"center"} style={{ marginBottom: 24 }}>
      <span style={titleTextStyle}>{label}</span>
      <PhoneInput
        country={"us"}
        value={value}
        onChange={(value) => onChange({ target: { value } })}
        disabled={editEnabled ? false : disabled}
        containerStyle={{
          width: "70%",
        //   marginBottom: 30,
          borderBottom: "2px solid #515563",
          border: "1px"
        }}
        inputStyle={{
          height: 40,
          width: "100%",
          background: editEnabled ? "#D2D2D2" : "#FFFFFF",
          border: "1px solid #7676801F",
          borderRadius: "4px",
        //   borderRadius: "10px 10px 0px 0px",
          color: "#515563",
          fontSize: 14,
          fontWeight: 500,
          fontFamily: "Avenir Book, sans-serif",
        }}
      />
    </Grid>
  );
};

const titleTextStyle = {
  width: "25%",
  color: "#020303",
  fontSize: 14,
  fontWeight: 700,
  fontFamily: "Avenir Book, sans-serif",
};

export default QTPhoneFieldWithLabelSection;

// Usage
// <QTPhoneFieldWithLabelSection
//   label="Phone"
//   value={addOrganizationField.phone}
//   onChange={(e) =>
//     setAddOrganizationField({
//       ...addOrganizationField,
//       phone: e.target.value,
//     })
//   }
//   disabled={false}
//   editEnabled={editEnabled}
// />
